import {
  Badge,
  Button,
  Checkbox,
  ConfigProvider,
  Form,
  Layout,
  List,
  Space,
  Typography,
} from "antd";
import React, { useContext, useMemo, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import file from "../components/download/authorization-form.pdf";
import { ThemeContext } from "../context/themeContext";
import CustomHeader from '../components/common/Header';
import { useTranslation, Trans } from "react-i18next";
import { ROUTES, LOGO_SVG_URL } from "../constants";

const { Title } = Typography;

const DownloadLink = () => {
  const { theme } = useContext(ThemeContext);
  const { t } = useTranslation();

  return (
    <a className={`${theme}-color`} href={file} download={true} size="small">
      {t("requirnment:hipaa_authorization")}
    </a>
  );
};
const Requirement = () => {
  const { t, i18n } = useTranslation();
  const { Content, Footer } = Layout;
  const navigate = useNavigate(); // Hook for navigation
  const [form] = Form.useForm();
  
  const data = useMemo(() => [
    <>
      {t("requirnment:if_not_patient_need_form")}{" "}
      <u>
        <DownloadLink />
      </u>{" "}
      {t("requirnment:form_download_text")}
    </>,
    <>
      {t("requirnment:requestor_signed_fmla")}
    </>,
    t("requirnment:patient_name_dob_address"),
    t("requirnment:employer_information"),
    t("requirnment:facility_location"),
  ], [t]);
  
  const validateAgreement = useCallback((_, value) => {
    if (value) {
      return Promise.resolve();
    }
    return Promise.reject(new Error(t("requirnment:please_accept_agreement")));
  }, [t]);
  
  const validationRules = useMemo(() => ({
    agreement: [{ validator: validateAgreement }]
  }), [validateAgreement]);
  const onFinish = (values) => {
    navigate(ROUTES.PATIENT_DETAILS_FMLA);
  };

  return (
    <ConfigProvider
      theme={{
        components: {
          List: {
            fontSize: 24,
            lineWidth: "0",
          },
          Layout: {
            footerPadding: 12,
          },
        },
      }}
    >
      <Layout className="bg-white">
          <CustomHeader />
          <Content className="p-6 pb-0">
            <Form form={form} onFinish={onFinish} key={`requirement-${i18n.language}`}>
              <div className="container mx-auto followingl-list">
                <List
                  size="small"
                  header={
                    <Title level={3}>
                      {t("requirnment:page_title")}
                    </Title>
                  }
                  footer={
                    <i className="text-base">
                      <Trans
                        i18nKey="requirnment:note_fee_message"
                        components={{
                          u: <u />,
                        }}
                      />
                    </i>
                  }
                  bordered={false}
                  dataSource={data}
                  renderItem={(item) => (
                    <List.Item className="followingl-list-item">
                      <Typography.Text>
                        {" "}
                        <Badge color="black" style={{ marginTop: "-1rem" }} />
                      </Typography.Text>{" "}
                      <span>{item}</span>
                    </List.Item>
                  )}
                />
                <Form.Item
                  name="agreement"
                  valuePropName="checked"
                  rules={validationRules.agreement}
                >
                  <Space className="w-full mb-5">
                    {" "}
                    <Checkbox className="font-medium">
                      <Trans
                        i18nKey="requirnment:i_have_all_required_info"
                        components={{
                          span: <span className="highlight-color" />,
                        }}
                      />
                    </Checkbox>
                  </Space>
                </Form.Item>
                <Space className="w-full mt-8 justify-between" align="baseline">
                  <Link to="/">
                    <Button type="primary">{t("common:back")}</Button>
                  </Link>
                  <Form.Item>
                    <Button
                      type="primary"
                      htmlType="submit"
                    >
                      {t("common:continue")}
                    </Button>
                  </Form.Item>
                </Space>
                <Footer className="welcome-footer bg-white">
                  <img
                    alt="Provider1st Logo"
                    className="m-auto"
                    src={window.location.origin + LOGO_SVG_URL}
                  />
                </Footer>
              </div>
            </Form>
          </Content>
        </Layout>
      </ConfigProvider>
  );
};

export default Requirement;
